import SocialActivityNotificationPayload from 'owa-service/lib/contract/SocialActivityNotificationPayload';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "AppNotifications", webpackPrefetch: true */ './lazyIndex')
);

export const lazySubscribeToNewMailNotifications = new LazyAction(
    lazyModule,
    m => m.subscribeToNewMailNotifications
);

export const lazySubscribeToReminderNotifications = new LazyAction(
    lazyModule,
    m => m.subscribeToReminderNotifications
);

export const lazySubscribeToSocialActivityNotifications = new LazyAction(
    lazyModule,
    m => m.subscribeToSocialActivityNotifications
);

export { SocialActivityNotificationPayload };

export { default as newMailNotificationAction } from './actions/newMailNotificationAction';
export { default as reminderNotificationAction } from './actions/reminderNotificationAction';
export { default as socialActivityNotificationAction } from './actions/socialActivityNotificationAction';
